import { FC, useRef } from 'react';
import { IStep } from './Stepper';

interface IStepperResponsiveProps {
    steps: IStep[];
    currentStep: number;
}

const StepperResponsive: FC<IStepperResponsiveProps> = ({ steps, currentStep }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const ctx = canvasRef.current?.getContext("2d"),
        radius = 21,
        circum = 2 * Math.PI * radius,
        lineWidth = 5,
        gap = lineWidth;
    const dashOn = circum / steps.length - gap;
    const temp = currentStep / steps.length;

    if (ctx) {
        ctx.clearRect(0, 0, 50, 50);                 // clear previous drawn content
        ctx.setTransform(1, 0, 0, 1, 25, 25);           // translate to center
        ctx.rotate(-Math.PI * 0.5);                      // rotate -90° so 0° is up

        ctx.beginPath();
        ctx.arc(0, 0, radius, Math.PI * 2 * temp, Math.PI * 2);   // circle from angle x t
        ctx.setLineDash([dashOn, gap]);                // set dash pattern
        ctx.lineDashOffset = -gap * 0.5;               // center dash gap
        ctx.lineWidth = lineWidth;                     // line width
        //ctx.lineCap = "round";                         // line width
        ctx.strokeStyle = "#9e9e9e";                      // base color
        ctx.stroke();                                  // render it

        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, Math.PI * 2 * temp);       // render arc based on angle x temp
        ctx.strokeStyle = "#00a693";                      // top color
        ctx.stroke();

        ctx.setLineDash([]);                           // reset dash
        ctx.setTransform(1, 0, 0, 1, 0, 0);
    }

    return (
        <div className="stepper-responsive">
            <div className="content">
                <div className="title">{`${steps[currentStep - 1].stepNumber}. ${steps[currentStep - 1].title}`}</div>
                <div className="desc">{steps[currentStep - 1].desc}</div>
            </div>
            <canvas className="canvas" ref={canvasRef} height="50" width="50" />
            <span className={`icon ${steps[currentStep - 1].icon}`} />
        </div >
    )
}

export default StepperResponsive;
